import React from "react";
import CryptoList from "./components/CryptoList.jsx";

function CryptoCurrencies() {
  return <CryptoList  />;
}

export default CryptoCurrencies;
